/*
  Core Web Vitals real-user monitoring (RUM).
  Tracks LCP, CLS, INP and TTFB using native PerformanceObserver.
  Zero external dependencies. Data is exposed on window.__webVitals and sent
  to GA4 as a web_vitals event through window.echoGa4Event
  (snippets/theme.external-scripts.liquid), which targets the main GA4
  property only.

  One event is sent the first time the page is hidden. Another follows on a
  later hide only if a value changed in between (the visitor came back and
  the page shifted, or a slower interaction happened). wv_id is the same for
  every event of one page load and report_seq counts them, so the event with
  the highest report_seq per wv_id holds the final values.

  Loaded deferred from layout/theme.liquid instead of inlined on every page
  (~2.3KB of uncacheable HTML per view). Deferring is safe for the metrics:
  every observer uses { buffered: true }, so entries recorded before this
  script runs are replayed to it, and TTFB is read from the navigation entry.

  page_type is read from the script tag's data-page-type attribute, since an
  external asset cannot be rendered by Liquid.
*/
(function () {
  'use strict';
  var tag = document.currentScript || document.querySelector('script[data-page-type]');
  var pageType = (tag && tag.getAttribute('data-page-type')) || '';
  var vitals = { lcp: 0, cls: 0, inp: Infinity, ttfb: 0 };
  var clsValue = 0;
  var inpEntries = [];

  // A browser that cannot measure a metric must not report it as 0
  function supports(type) {
    try {
      var types = PerformanceObserver.supportedEntryTypes;
      return !!types && types.indexOf(type) !== -1;
    } catch(e) {
      return false;
    }
  }
  var clsSupported = supports('layout-shift');

  // TTFB
  try {
    var nav = performance.getEntriesByType('navigation')[0];
    if (nav) vitals.ttfb = Math.round(nav.responseStart);
  } catch(e) {}

  // LCP
  try {
    var lcpObs = new PerformanceObserver(function(list) {
      var entries = list.getEntries();
      var last = entries[entries.length - 1];
      if (last) vitals.lcp = Math.round(last.startTime);
    });
    lcpObs.observe({ type: 'largest-contentful-paint', buffered: true });
  } catch(e) {}

  // CLS
  try {
    var clsObs = new PerformanceObserver(function(list) {
      var entries = list.getEntries();
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].hadRecentInput) {
          clsValue += entries[i].value;
        }
      }
      vitals.cls = Math.round(clsValue * 1000) / 1000;
    });
    clsObs.observe({ type: 'layout-shift', buffered: true });
  } catch(e) {}

  // INP (Interaction to Next Paint)
  try {
    var inpObs = new PerformanceObserver(function(list) {
      var entries = list.getEntries();
      for (var i = 0; i < entries.length; i++) {
        inpEntries.push(entries[i].duration);
      }
      if (inpEntries.length > 0) {
        inpEntries.sort(function(a, b) { return a - b; });
        var idx = Math.min(inpEntries.length - 1, Math.floor(inpEntries.length * 0.98));
        vitals.inp = Math.round(inpEntries[idx]);
      }
    });
    inpObs.observe({ type: 'event', buffered: true, durationThreshold: 40 });
  } catch(e) {}

  // Expose for debugging
  window.__webVitals = vitals;

  // Report when the page is hidden. Leaving a page fires both visibilitychange and
  // pagehide, so an unchanged set of values is never sent a second time.
  var loadId = Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
  var lastSent = '';
  var seq = 0;
  function reportVitals() {
    if (typeof window.echoGa4Event !== 'function') return;

    var params = {
      event_category: 'Web Vitals',
      page_type: pageType,
      non_interaction: true
    };
    // Metrics that were never measured are left out instead of being sent as 0
    if (vitals.lcp > 0) params.lcp_ms = vitals.lcp;
    if (clsSupported) params.cls_score = vitals.cls;
    if (vitals.inp !== Infinity) params.inp_ms = vitals.inp;
    if (vitals.ttfb > 0) params.ttfb_ms = vitals.ttfb;

    var values = [params.lcp_ms, params.cls_score, params.inp_ms, params.ttfb_ms].join('|');
    if (values === lastSent) return;
    lastSent = values;

    seq += 1;
    params.wv_id = loadId;
    params.report_seq = seq;

    window.echoGa4Event('web_vitals', params);
  }

  // Use visibilitychange for reliable reporting
  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'hidden') reportVitals();
  });

  // Fallback for browsers that do not fire visibilitychange on navigation (older Safari)
  window.addEventListener('pagehide', reportVitals);
})();
